export default {
  methods: {
    getTenantSignUpData () {
      if (localStorage.getItem('tenant_sign_up')) {
        const tenantSignUp = JSON.parse(localStorage.getItem('tenant_sign_up'))
        const expired = Date.parse(tenantSignUp.expired)
        if (!tenantSignUp.confirmed && expired < (new Date())) {
          localStorage.removeItem('tenant_sign_up')
        } else {
          return tenantSignUp
        }
      }
    },
    setTenantSignUpData (key, value) {
      let tenantSignUp = JSON.parse(localStorage.getItem('tenant_sign_up'))
      if (!tenantSignUp) {
        tenantSignUp = {}
      }
      tenantSignUp[key] = value
      localStorage.setItem('tenant_sign_up', JSON.stringify(tenantSignUp))
    }
  }
}
